
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#fff"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.912 4c-3.298 0-5.583.011-6.756 1.157C4.011 6.329 4 8.72 4 11.912c3.543-.107 5.163-.196 6.455-1.458 1.261-1.292 1.35-2.911 1.457-6.454zM5.156 18.843C4.011 17.671 4 15.28 4 12.088c3.542.107 5.162.196 6.454 1.458 1.262 1.292 1.35 2.912 1.458 6.454-3.298 0-5.583-.01-6.756-1.157zM12.088 20c.107-3.542.196-5.162 1.458-6.454 1.292-1.262 2.912-1.35 6.454-1.458 0 3.19-.011 5.583-1.157 6.755C17.671 19.99 15.386 20 12.088 20zm0-16c.107 3.543.196 5.162 1.458 6.454 1.292 1.262 2.912 1.35 6.454 1.458 0-3.19-.011-5.583-1.157-6.755C17.671 4.01 15.386 4 12.088 4z","fill":"#2B2B2B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M4 4h16v16H4z"}})])])])
          )
        }
      }
    